export const WarrantySlug = 'garantie';

export function getWarrantyUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${WarrantySlug}`;
}
